import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    discountList: [],
    lastQuery: null,
};

const getters = {
    discountList: state => {
        return state.discountList;
    },
};

const mutations = {
    setDiscountList(state, data) {
        state.discountList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const actions = {
    createDiscount({ commit, dispatch }, discount) {
        startLoading(dispatch, 'save-discount');

        return axios
            .post(Laroute.route('franchise.setting.discount.store'), discount)
            .then(res => {
                endLoading(dispatch, 'save-discount');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-discount');
                throw err;
            });
    },

    getDiscount({ commit, dispatch }, id) {
        let discount = state.discountList.find(d => d.id === id);

        if (discount !== undefined) {
            return Promise.resolve(discount);
        }

        startLoading(dispatch, 'get-discount');

        return axios
            .get(Laroute.route('franchise.setting.discount.show', { id: id }))
            .then(res => {
                endLoading(dispatch, 'get-discount');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-discount');
                throw err;
            });
    },

    getDiscountListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.discountList.length || state.lastQuery !== params.query) {
            dispatch('getDiscountList', params);
        }
    },

    getDiscountList({ commit, dispatch }, params = {}) {
        let options = {
            params: _.merge(
                {
                    limit: 10,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-discount');

        return axios
            .get(Laroute.route('franchise.vue.discounts'), options)
            .then(res => {
                let data = res.data.data;

                commit('setDiscountList', data);
                commit('setLastQuery', params.query);
                endLoading(dispatch, 'fetch-discount');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-discount');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/discount.js